import classnames from 'classnames'
import { __ } from '@wordpress/i18n'
import { compose } from '@wordpress/compose'
import {
	addFilter,
	applyFilters
} from '@wordpress/hooks'
import {
	PanelBody,
	RangeControl,
	ToggleControl,
	SelectControl,
	Disabled
} from '@wordpress/components'
import {
	Fragment,
	useRef,
	useEffect,
} from '@wordpress/element'

import {
	ResponsiveControl,
	AdvancedRangeControl
} from '~cartzillagb/components'
import {
	withUniqueClass,
	withSetAttributeHook,
	withBlockStyles,
	withTabbedInspector,
} from '~cartzillagb/higher-order'
import { i18n } from 'cartzillagb'

import createStyles from './style'
import Block from './block'
import $ from 'jquery'

import './common'

addFilter( 'cartzillagb.brands.edit.inspector.style.before', 'cartzillagb/brands', ( output, props ) => {
	const {
		attributes,
		setAttributes
	} = props

	const {
		enableContainer,
		number,
		columns,
		orderby,
		order,
		hide_empty,

		// Carousel.
		enableCarousel,
	} = attributes

	return (
		<Fragment>
			<PanelBody
				title={ __( 'General', i18n ) }
				initialOpen={ true }
			>
				<ToggleControl
					label={ __( 'Container', i18n ) }
					checked={ enableContainer }
					onChange={ enableContainer => setAttributes( { enableContainer } ) }
				/>
				<ToggleControl
					label={ __( 'Enable Carousel', i18n ) }
					checked={ enableCarousel }
					onChange={ enableCarousel => setAttributes( { enableCarousel } ) }
				/>
				<RangeControl
					label={ __( 'Limit', i18n ) }
					value={ number }
					onChange={ number => setAttributes( { number } ) }
					min={ 1 }
					max={ applyFilters( 'cartzillagb.brands.edit.inspector.max.number', 30 ) }
				/>
				{ ! ( enableCarousel ) &&
					<RangeControl
						label={ __( 'Columns', i18n ) }
						value={ columns }
						onChange={ columns => setAttributes( { columns } ) }
						min={ 1 }
						max={ applyFilters( 'cartzillagb.brands.edit.inspector.max.columns', 8 ) }
					/>
				}
				<SelectControl
					label={ __( 'Orderby', i18n ) }
					value={ orderby }
					options={ [
						{ value: 'name', label: __( 'Name', i18n ) },
						{ value: 'date', label: __( 'Date', i18n ) },
						{ value: 'id', label: __( 'ID', i18n ) },
						{ value: 'menu_order', label: __( 'Menu Order', i18n ) },
						{ value: 'count', label: __( 'count', i18n ) },
						{ value: 'rand', label: __( 'Random', i18n ) },
					] }
					onChange={ orderby => setAttributes( { orderby } ) }
				/>
				<SelectControl
					label={ __( 'Order', i18n ) }
					value={ order }
					options={ [
						{ value: 'ASC', label: __( 'ASC', i18n ) },
						{ value: 'DESC', label: __( 'DESC', i18n ) },
					] }
					onChange={ order => setAttributes( { order } ) }
				/>
				<ToggleControl
					label={ __( 'Hide Empty', i18n ) }
					checked={ hide_empty }
					onChange={ hide_empty => setAttributes( { hide_empty } ) }
				/>
			</PanelBody>
			{ enableCarousel && (
				<PanelBody title={ __( "Carousel Options", i18n ) } initialOpen={ true }>
					<ResponsiveControl
						attrNameTemplate="slidesToShow%s"
						setAttributes={ setAttributes }
						blockAttributes={ attributes }
						screens={ [ 'desktop', 'laptop', 'tablet', 'mobile' ] }
					>
						<AdvancedRangeControl
							label={ __( 'Slides To Show', i18n ) }
							min={ 1 }
							max={ applyFilters( 'cartzillagb.brands.edit.inspector.max.slidesToShow', 8 ) }

						/>
					</ResponsiveControl>
				</PanelBody>
			) }
		</Fragment>
	)
} )

const edit = props => {
	const {
		blockName,
		styles,
		clientId,
		attributes,
		setAttributes,
		className,
	} = props

	const {
		blockId,
		enableContainer,

		// Carousel.
		enableCarousel,
	} = attributes

	const slickEl = useRef( blockId || clientId )

	useEffect( () => {
		if ( enableCarousel && slickEl.current !== undefined && $( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).length ) {
			$( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).slick( 'refresh' )
		}
	}, [
		enableContainer
	] )

	const setBlockId = blockId => setAttributes({ blockId })

	if ( clientId !== blockId ) {
		setBlockId( clientId )
	}

	const mainClasses = classnames( [
		className,
	], {
		'cz-carousel' : enableCarousel
	} )

	const output = (
		<div ref={ slickEl } id={ blockId || clientId } className={ mainClasses }>
			{ styles }
			<div className={ classnames( [], {
				'container' : enableContainer,
				'mb-5' : enableCarousel,
				'py-lg-4' : ! enableCarousel,
			} ) }>
				{ applyFilters( `cartzillagb.${ blockName }.edit.output.block-title`, null, null, props ) }
				<div className={ 'ajax-content' } >
					<Disabled>
						<Block attributes={ { ...attributes } } />
					</Disabled>
				</div>
			</div>
		</div>
	)

	return output
}

export default compose(
	withUniqueClass,
	withSetAttributeHook,
	withBlockStyles( createStyles, { editorMode: true } ),
	withTabbedInspector( [ 'style', 'advanced' ] ),
)( edit )
